/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import _ from "lodash";
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData, persistAddress } from "./persisterService";
import { persistLitigationSubEntities } from "./AbstractLitigationCasePersister";
import { UseForm } from "../../types/UseForm";
import { EmploymentContract } from "../../types/Products/EmploymentLaw/EmploymentContract";

export const persistEmploymentContractCase = async (
  updateData: UseForm["values"],
  origEmploymentContractCase: EmploymentContract
) => {
  await persistLitigationSubEntities(updateData, origEmploymentContractCase);

  if (
    _.has(updateData, "employmentRegularWorkplaceOtherAddress") &&
    _.isObject(updateData.employmentRegularWorkplaceOtherAddress)
  ) {
    const employmentRegularWorkplaceOtherAddressData = getUpdateData(
      updateData.employmentRegularWorkplaceOtherAddress,
      origEmploymentContractCase,
      "employmentRegularWorkplaceOtherAddress"
    );
    await persistAddress(
      origEmploymentContractCase.employmentRegularWorkplaceOtherAddress.id,
      employmentRegularWorkplaceOtherAddressData
    );
  }

  const apiUri = getProductData(origEmploymentContractCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origEmploymentContractCase);

  await apiPatch(apiUri, origEmploymentContractCase.id, contractCaseUpdateData);
};
